// src/components/layouts/main/sider/sidebarNavigation.ts
import { useAppSelector } from '@app/hooks/reduxHooks';
import { RootState } from '@app/store/store';

import { useContext } from 'react';
import { VariantContext } from '@app/variant';
import { CONTROL_MENU } from '@app/panels/control/controlMenu';
import { USER_MENU } from '@app/panels/user/userMenu';

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  selectedIcon?: React.ReactNode;
  show?: boolean;
}

export const getSidebarNavigation = (): SidebarNavigationItem[] => {
  const state: RootState = useAppSelector((s) => s);
  const { id } = useContext(VariantContext); // "control" | "user"

  if (id === 'control') {
    return CONTROL_MENU(state);
  }
  return USER_MENU(state);
};
